import { getCorrelationID } from 'utils/tagular';
import makeEvent from './makeEvent';
import { ConversionEvents, ConversionTracked } from './types';
import { EVENTS } from './types/events';

const conversionEvents: ConversionEvents = (data) => {
  const correlationId = getCorrelationID();
  const conversionEvent = makeEvent<ConversionTracked, EVENTS>(data);

  return {
    conversionTracked: (override) => {
      conversionEvent<ConversionTracked>(EVENTS.ConversionTracked)({
        correlation: {
          id: correlationId,
        },
        ...override,
      });
    },
    correlationId,
  };
};

export default conversionEvents;
